import type { RouteLocationRaw } from 'vue-router';
import type { NotificationItem } from '@/store/notification';

export type NotificationDestination
  = | { kind: 'route'; to: RouteLocationRaw }
    | { kind: 'external'; url: string };

export function getVisualizationReviewDashboardUrl() {
  const backendOrigin = import.meta.env.DEV
    ? 'http://127.0.0.1:8000'
    : window.location.origin;
  return `${backendOrigin}/backend-dashboard/video/visualizationresource/?review_status__exact=pending`;
}

export function openExternalNotificationDestination(url: string) {
  const openedWindow = window.open('about:blank', '_blank');
  if (!openedWindow)
    return false;
  openedWindow.opener = null;
  openedWindow.location.href = url;
  return true;
}

export function getNotificationDestination(item: NotificationItem, _isAdmin: boolean): NotificationDestination {
  if (item.event === 'course_review_submitted') {
    return {
      kind: 'route',
      to: { path: '/admin/course-reviews' },
    };
  }

  if (item.event === 'course_review_approved' || item.event === 'course_review_rejected' || item.event === 'course_review_delisted') {
    return {
      kind: 'route',
      to: { path: '/my-courses' },
    };
  }

  if (item.event === 'visualization_review_submitted' || item.event === 'visualization_review_resubmitted') {
    return {
      kind: 'route',
      to: { path: '/visualization' },
    };
  }

  if (item.event === 'course_content_updated') {
    return {
      kind: 'route',
      to: item.payload.courseId
        ? { path: `/courses/${item.payload.courseId}` }
        : { path: '/' },
    };
  }

  return {
    kind: 'route',
    to: { path: '/visualization' },
  };
}
